import React from 'react';
import StatusBadge from './StatusBadge';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function formatCurrency(amount) {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);
}

function getStatus(campaign) {
  // Backend returns flat deliveryStatus field
  const ds = campaign.deliveryStatus;
  if (ds === 'PAID') return 'paid';
  if (ds === 'POSTED' || ds === 'VERIFIED') return 'posted';
  if (ds === 'SHOWED_ACTIVITY') return 'active';
  return 'active';
}

export default function CampaignCard({ campaign, completed: isCompleted, onClick, actionLabel, onAction, actionDisabled }) {
  const status = isCompleted ? 'paid' : getStatus(campaign);
  const completed = status === 'paid';

  return (
    <div
      className="camp-card"
      onClick={onClick}
      style={{
        ...(completed ? { opacity: 0.5 } : {}),
        ...(!onClick ? { cursor: 'default' } : {})
      }}
    >
      <div className="camp-left">
        <div className="camp-brand">{campaign.name}</div>
        <div className="camp-type">
          {campaign.campaignType || campaign.pricingType || ''}
        </div>
        {campaign.notice && (
          <div className="camp-notice">{campaign.notice}</div>
        )}
        <div className="camp-meta">
          {campaign.endDate && (
            <div className="camp-meta-item">
              <strong>{completed ? 'Completed:' : 'Deadline:'}</strong> {formatDate(campaign.endDate)}
            </div>
          )}
          {campaign.payment != null && (
            <div className="camp-meta-item">
              <strong>{completed ? 'Earned:' : 'Payment:'}</strong> {formatCurrency(campaign.payment)}
            </div>
          )}
        </div>
      </div>
      <div className="camp-right">
        <StatusBadge status={status} />
        {actionLabel && (
          <button
            className="camp-action"
            disabled={actionDisabled}
            onClick={(event) => {
              event.stopPropagation();
              onAction?.();
            }}
          >
            {actionLabel}
          </button>
        )}
        {!completed && onClick && <div className="camp-arrow">&rarr;</div>}
      </div>
    </div>
  );
}
